<template>
	<section ref="el" data-component="insights">
		<div class="g-row title-row">
			<div class="g-col xxl-7 xxl-offset-1 xs-14 xs-offset-0">
				<h3 class="-title-5 title">
					<SanityContent :value="title" :components="components" />
				</h3>
			</div>

			<div class="g-col xxl-2 xxl-offset-5 xs-14 xs-offset-0 button-col">
				<Button v-bind="cta" tone="primary" />
			</div>
		</div>

		<div class="g-row insight-row">
			<div class="g-col xxl-14 xs-16">
				<InsightWrapper v-bind="featuredInsight" />
			</div>
		</div>

		<div class="g-row call-to-action-row">
			<div class="g-col xxl-6 sm-14">
				<h3 class="-title-5 title">
					<SanityContent :value="callToAction.title" :components="components" />
				</h3>
				<Button v-bind="callToAction.cta" tone="primary" />
			</div>
		</div>
	</section>
</template>

<script setup>
import { h } from 'vue'
import { InsightWrapper } from '~/components/fragments'

import { Button } from '~/components/primitives'

defineProps({
	title: { type: Array, default: undefined },
	cta: { type: Object, default: undefined },
	featuredInsight: { type: Object, default: undefined },
	callToAction: { type: Object, default: undefined },
})

const components = {
	block: {
		normal: (_, { slots }) => h('span', { class: 'title-line' }, slots.default?.()),
	},
}

const el = ref(null)
const context = inject('pageContext')

const setup = () => {}
const init = () => {}
onMounted(() => {
	const loader = context?.$page?.loader

	loader.loaded.then(() => setup())
	loader.transitionReady.then(() => init())
})
</script>

<style lang="scss" scoped>
[data-component='insights'] {
	position: relative;

	margin-top: rs(105, 50);
	margin-bottom: rs(48, 48);

	.title {
		white-space: pre-line;

		& :deep(.title-line) {
			display: block;
			@include inherit-font;

			color: var(--color-neutral-tints-900);

			&:first-child {
				text-indent: column-width(2, true);
			}
		}

		& :deep(strong) {
			color: var(--color-river-blue-500);
			@include inherit-font;
		}
	}

	.title-row {
		margin-bottom: rs(24, 42);

		display: flex;
		flex-direction: row;
		align-items: flex-end;

		.button-col {
			display: flex;
			justify-content: flex-end;

			@include max-width($xs) {
				justify-content: flex-start;
				margin-top: rs(12, 12);
			}
		}
	}

	.insight-row {
		justify-content: center;

		:deep(.insight-wrapper) {
			// max-height: rs(600);
			height: rs(630, 535);
			@include max-width($xs) {
				height: rs(400, 400);
			}

			@include max-width($xs) {
				height: rs(400, 400);
			}

			.image-wrapper {
				height: rs(630, 535);
				max-height: rs(630, 535);

				@include max-width($xs) {
					height: rs(400, 400);
					max-height: rs(400, 400);
				}

				.media-mask {
					height: rs(630, 535);
					min-height: rs(630, 535);

					@include max-width($xs) {
						height: rs(400, 400);
						min-height: rs(400, 400);
					}
				}
			}
		}
	}

	.call-to-action-row {
		justify-content: flex-end;

		margin-top: rs(96, 46);

		@include max-width($sm) {
			justify-content: flex-start;
		}

		.g-col {
			margin-right: column-width(1, true);

			.title {
				margin-bottom: rs(20, 20);
			}
		}
	}
}
</style>
